import React from 'react';
import { Link } from 'react-router';
import { FaWhatsapp, FaCheck } from 'react-icons/fa';
import SignUpForm from '../components/SignUpForm';
import { PHONE, WHATSAPP_HREF } from '../site';
import { track } from '../analytics';

const offerings = [
  'Online, with 24/7 assistance',
  'Past paper questions and full syllabus coverage',
  'Tailored classes and personalised feedback',
];

// Source order is the mobile order: pitch, then the form, then the rest.
// On large screens the two text blocks stack in column two beside the form.
const Home = () => (
  <section className="mx-auto grid max-w-6xl items-start gap-x-12 gap-y-8 px-6 py-16 lg:grid-cols-2">
    <div className="text-center lg:col-start-2 lg:row-start-1 lg:text-left">
      <img
        src="/images/logo.png"
        alt=""
        className="mx-auto mb-6 h-24 w-24 object-contain lg:mx-0"
      />

      <h1 className="text-4xl font-extrabold leading-tight text-navy md:text-5xl">
        Velocity Learning
      </h1>
      <p className="mt-2 text-lg font-semibold text-navy/70">The best for your test.</p>

      <p className="mt-5 text-lg leading-relaxed text-gray-700">
        We want to help you do well in CSEC and CAPE mathematics.
        Classes start in September.
      </p>
    </div>

    <div className="lg:col-start-1 lg:row-span-2 lg:row-start-1">
      <SignUpForm />
    </div>

    <div className="text-center lg:col-start-2 lg:row-start-2 lg:text-left">
      <ul className="flex flex-col gap-2.5 text-left">
        {offerings.map((item) => (
          <li key={item} className="flex items-start gap-3 text-gray-700">
            <FaCheck aria-hidden="true" className="mt-1.5 flex-none text-navy" />
            {item}
          </li>
        ))}
      </ul>

      <div className="mt-8 flex justify-center lg:justify-start">
        <a
          href={WHATSAPP_HREF}
          target="_blank"
          rel="noreferrer"
          onClick={() => track('Contact')}
          className="flex items-center gap-3 rounded-lg bg-navy px-7 py-4 text-lg font-medium text-white transition hover:bg-navy-light"
        >
          <FaWhatsapp aria-hidden="true" className="text-2xl" />
          WhatsApp us: {PHONE}
        </a>
      </div>

      <p className="mt-6 flex flex-col gap-1 text-gray-600 sm:flex-row sm:justify-center sm:gap-4 lg:justify-start">
        <Link to="/classes" className="font-medium text-navy underline">
          See the class schedule
        </Link>
        <Link to="/reviews" className="font-medium text-navy underline">
          Read student reviews
        </Link>
      </p>
    </div>
  </section>
);

export default Home;
